import React from 'react';
import { I18n } from 'aws-amplify';

function PpmsServiceItem(props) {
    console.log(props.url);
    return(
        <div className="serviceItem">
            <div className="serviceItemInner">
                <h2><span className="mypageTitleIcon"></span>{I18n.get('Power Plant Management')}</h2>
                <p></p>
                <a className="menuButton blue" href={props.url} onClick={props.onClick}>{I18n.get('Open')}</a>
            </div>
        </div>
    );
}
export default PpmsServiceItem;